const DashboardMoodCard = ({
  icon,
  title,
  items,
  backgroundColor = "#5153F5",
}) => {
  return (
    <div className="h-full w-full rounded-2xl border border-gray-200 bg-white shadow-sm">
      <div
        style={{
          backgroundColor: backgroundColor,
        }}
        className="flex flex-row justify-start items-center border-b border-gray-200 rounded-t-2xl px-4 pb-4 pt-4"
      >
        {icon}
        <h6 className="text-base font-semibold text-white">{title}</h6>
      </div>

      <div className="flex flex-col items-center justify-between px-4 py-2">
        <div className="flex flex-row justify-center items-center mt-3">
          {items?.length > 0 &&
            items?.map((item) => (
              <div
                key={`mood-${item?.type ?? ""}`}
                className="flex flex-col justify-center items-center mx-6"
              >
                <img
                  className="w-14 h-14 rounded-xl"
                  src={
                    item?.type == "sad"
                      ? require("../../assets/images/moods/ic_sad.webp")
                      : item?.type == "unhappy"
                      ? require("../../assets/images/moods/ic_unhappy.webp")
                      : item?.type == "okay"
                      ? require("../../assets/images/moods/ic_okay.webp")
                      : item?.type == "happy"
                      ? require("../../assets/images/moods/ic_happy.webp")
                      : require("../../assets/images/moods/ic_elated.webp")
                  }
                />
                <p className="font-semibold text-base mt-1 mb-1">
                  {item?.percentage?.toFixed(2) ?? 0}%
                </p>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default DashboardMoodCard;
